import { axiosRequest } from '@/util/axios-request'

export const get_tab = data =>
  axiosRequest({ url: '/web/payroll_sub_project_scheme/get_tab', method: 'get', params: data || {} })

// 获取考勤组数据
export const get_attendance = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/get_attendance', data })

// 保存考勤组数据
export const save_attendance = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/save_attendance', data })

// 获取薪资组数据
export const get_salary = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/get_salary', data })

// 保存薪资组数据
export const save_salary = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/save_salary', data })

// 获取税组数据
export const getTax = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/get_tax', data })

// 保存税组数据
export const saveTax = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/save_tax', data })

// 获取税组数据
export const getSocialSecurity = data =>
  axiosRequest({ url: '/web/payroll_sub_project_scheme/get_social_security', data })

// 保存社保组数据
export const saveSocialSecurity = data =>
  axiosRequest({ url: '/web/payroll_sub_project_scheme/save_social_security', data })

// 计薪方案-其他设置列表
export const getDeductSort = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/getDeductSort', data })

// 计薪方案-其他设置—保存
export const saveDeductSort = data => axiosRequest({ url: '/web/payroll_sub_project_scheme/saveDeductSort', data })
